import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { NotificationFacade, PaymentMethodsFacade, SwishFacade } from '@ridango/components';
import { loadCartState, loadPaymentState } from '@ridango/components/lib/localStorage';
import { BankLinkPayment, PaymentMethod, SwishTransactionStatus } from '@ridango/core';

import { interval as observableInterval, Observable, Subscription } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'rwidget-swish-loading',
    templateUrl: './swish-loading.component.html'
})
export class SwishLoadingComponent extends BaseComponent implements OnInit, OnDestroy {
    transaction$: Observable<BankLinkPayment> = this.swishFacade.transaction$;
    paymentMethod$: Observable<PaymentMethod> = this.paymentMethodFacade.selectedPaymentMethod$;
    pollStatus$: Subscription;

    paymentMethod: PaymentMethod;
    locale = this.translate.currentLang;
    constructor(
        private router: Router,
        private notifications: NotificationFacade,
        private translate: TranslateService,
        private swishFacade: SwishFacade,
        private paymentMethodFacade: PaymentMethodsFacade
    ) {
        super();
    }

    ngOnInit() {
        this.transaction$.pipe(take(1)).subscribe((t: BankLinkPayment) => {
            t = t ? t : loadCartState();

            if (t) {
                this.checkPayment(t);
            } else {
                window.scroll(0, 0);
                this.notifications.error(this.translate.instant('LOCAL_NO_SWISH_TRANSACTION_DATA'), {
                    showAfterRouteChange: true
                });
                this.router.navigate([this.locale, 'purchase']);
            }
        });
    }

    ngOnDestroy() {
        if (this.paymentMethod) {
            this.pollStatus$.unsubscribe();
        }
        this.swishFacade.clearTransactionData();
        this.swishFacade.setTransactionStatus(null);
        super.ngOnDestroy();
    }

    checkPayment(t: BankLinkPayment) {
        this.swishFacade.setTransactionStatus(SwishTransactionStatus.PENDING);
        this.paymentMethod$.pipe(take(1)).subscribe((pm: PaymentMethod) => {
            pm = pm ? pm : loadPaymentState();

            if (pm && t) {
                this.paymentMethod = pm;
                this.pollStatus$ = this.getStatus(pm.payment_id, t)
                    .pipe(takeUntil(this.componentDestroyed$))
                    .subscribe(
                        (d) => {
                            if (d.status === 200) {
                                this.swishFacade.setTransactionStatus(SwishTransactionStatus.SUCCESS);
                                this.notifications.success(this.translate.instant('LOCAL_SWISH_PAYMENT_SUCCESS'), {
                                    showAfterRouteChange: true
                                });
                                this.router.navigate([this.locale, 'purchase', 'result'], {
                                    queryParams: { result: 'S' }
                                });
                            }
                        },
                        (e) => {
                            this.swishFacade.setTransactionStatus(SwishTransactionStatus.FAIL);
                            this.notifications.error(this.translate.instant(e.error), {
                                showAfterRouteChange: true
                            });
                            this.router.navigate([this.locale, 'purchase', 'result'], {
                                queryParams: { result: 'F' }
                            });
                        }
                    );
            } else {
                this.notifications.error(this.translate.instant('LOCAL_NO_SWISH_TRANSACTION_DATA'), {
                    showAfterRouteChange: true
                });
                this.router.navigate([this.locale, 'purchase']);
            }
            window.scroll(0, 0);
        });
    }

    getStatus(payment, transaction) {
        return observableInterval(5000).pipe(
            mergeMap(() => {
                return this.swishFacade.getPaymentStatus(transaction.shopping_cart_id, payment);
            })
        );
    }
}
